  // Switch language

  // Rava: switchers are matched by class, not id, so the header and the mobile
  // menu can each carry one. getElementById only ever found the first, and if
  // the element was missing it threw and killed the rest of this file.
  var langBtns = document.querySelectorAll('.rava-lang-btn');

  // Rava: English is now a real Shopify language served at /en/, not just a
  // class on the body. That matters beyond the storefront: Shopify decides the
  // checkout language and the order email language from the locale the customer
  // was actually browsing, so a visitor who only had the class flipped would
  // still reach a Hungarian checkout. Switching therefore navigates.
  //
  // Hungarian stays at the root, so every existing URL, and every ad pointing
  // at one, is untouched.
  function ravaShopifyLocale() {
      try {
          if (window.Shopify && Shopify.locale) { return Shopify.locale.slice(0, 2).toLowerCase(); }
      } catch (e) {}
      // Fall back to reading the path, in case the global is not there yet.
      return /^\/en(\/|$)/.test(location.pathname) ? 'en' : 'hu';
  }

  // The same page in the other language.
  function ravaUrlFor(language) {
      var path = location.pathname.replace(/^\/en(?=\/|$)/, '') || '/';
      if (language === 'en') { path = '/en' + (path === '/' ? '/' : path); }

      // The old ?lang= parameter is redundant once the language is in the path.
      var search = '';
      try {
          var url = new URL(location.href);
          url.searchParams.delete('lang');
          search = url.search;
      } catch (e) { search = location.search; }

      return path + search + location.hash;
  }

  function ravaSyncUrl(language) {
      // Nothing to rewrite: the language lives in the path now, and it is
      // Shopify that put it there.
      return language;
  }

  // Function to set the active language and class
  function setActiveLanguage(language) {
      if (language !== 'en') { language = 'hu'; }
      if (language === 'en') {
          document.body.classList.remove('hu-lang');
          document.body.classList.add('en-lang');
      } else {
          document.body.classList.remove('en-lang');
          document.body.classList.add('hu-lang');
      }
      for (var b = 0; b < langBtns.length; b++) {
          if (langBtns[b].getAttribute('data-lang') === language) {
              langBtns[b].classList.add('active');
          } else {
              langBtns[b].classList.remove('active');
          }
      }
      ravaSyncUrl(language);
  }

  // Function to handle button clicks
  function handleButtonClick(event) {
      var language = event.currentTarget.getAttribute('data-lang');
      if (language !== 'en') { language = 'hu'; }
      try { localStorage.setItem('activeLanguage', language); } catch (e) {}

      // Rava: the visitor's own choice, kept apart from activeLanguage, which is
      // written on every page load and so cannot tell a choice from a default.
      // The head of theme.liquid reads this before sending an automatically
      // redirected visitor back to Hungarian.
      try { localStorage.setItem('ravaLangChoice', language); } catch (e) {}

      // Already on that language's URLs: just repaint, no navigation.
      if (ravaShopifyLocale() === language) {
          setActiveLanguage(language);
          return;
      }

      if (event.preventDefault) { event.preventDefault(); }
      window.location.href = ravaUrlFor(language);
  }

  // Add event listeners to every switcher on the page
  for (var lb = 0; lb < langBtns.length; lb++) {
      langBtns[lb].addEventListener('click', handleButtonClick);
  }

  // --- Rava: decide the starting language ------------------------------
  //
  // Shopify's own locale wins, because it is the one in the URL and the one
  // the checkout and the order emails will follow. The body class simply
  // mirrors it, so the translated blocks agree with the page they are on.
  //
  // ?lang=en is still honoured for links shared before /en/ existed, including
  // anything already running in ads. Those are sent to the real English URL
  // once, so the visitor ends up somewhere the checkout can follow.
  var ravaParam = null;
  try {
    ravaParam = (location.search.match(/[?&]lang=(hu|en)/i) || [])[1];
    if (ravaParam) { ravaParam = ravaParam.toLowerCase(); }
  } catch (e) {}

  var ravaLocale = ravaShopifyLocale();

  // A ?lang= link was shared or clicked on purpose, so it counts as a choice.
  if (ravaParam) {
    try { localStorage.setItem('ravaLangChoice', ravaParam); } catch (e) {}
  }

  if (ravaParam && ravaParam !== ravaLocale) {
    try { localStorage.setItem('activeLanguage', ravaParam); } catch (e) {}
    window.location.replace(ravaUrlFor(ravaParam));
  } else {
    setActiveLanguage(ravaLocale);
    try { localStorage.setItem('activeLanguage', ravaLocale); } catch (e) {}
  }

  // --- Swym wishlist gomb felirat javítás (EN: Add to Wishlist) ---
(function () {
  var HU = 'Hozzáadás a kedvencekhez';
  var EN = 'Add to Wishlist';

  function isEnglish() {
    return document.body.classList.contains('en-lang') ||
           document.documentElement.lang.indexOf('en') === 0;
  }

  function fixAll() {
    var source = isEnglish() ? HU : EN;
    var target = isEnglish() ? EN : HU;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.textContent.indexOf(source) !== -1) {
        node.textContent = node.textContent.replace(source, target);
      }
    }
  }

  function start() {
    fixAll();
    // A Swym késve tölti be a gombot, ezért figyeljük a DOM változásait
    new MutationObserver(fixAll).observe(document.body, { childList: true, subtree: true });
    // Nyelvváltó gombokra is fusson le
    ['en-btn', 'hu-btn'].forEach(function (id) {
      var btn = document.getElementById(id);
      if (btn) btn.addEventListener('click', function () { setTimeout(fixAll, 0); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();